// This file is auto-generated by joy-translate. Do not edit manually.
import allTheLittleDetails from 'src/locales/en/allTheLittleDetails.json';
import amazonRegistry from 'src/locales/en/amazonRegistry.json';
import app from 'src/locales/en/app.json';
import avatar from 'src/locales/en/avatar.json';
import babyRegistry from 'src/locales/en/babyRegistry.json';
import blogCarousel from 'src/locales/en/blogCarousel.json';
import careers from 'src/locales/en/careers.json';
import carouselQuotes from 'src/locales/en/carouselQuotes.json';
import cashFundRegistry from 'src/locales/en/cashFundRegistry.json';
import chatGPT from 'src/locales/en/chatGPT.json';
import demo from 'src/locales/en/demo.json';
import designs from 'src/locales/en/designs.json';
import errors from 'src/locales/en/errors.json';
import eula from 'src/locales/en/eula.json';
import faq from 'src/locales/en/faq.json';
import findAnEvent from 'src/locales/en/findAnEvent.json';
import findPerfectInvitationsSection from 'src/locales/en/findPerfectInvitationsSection.json';
import footerNavs from 'src/locales/en/footerNavs.json';
import galleryPage from 'src/locales/en/galleryPage.json';
import getQuickAddButton from 'src/locales/en/getQuickAddButton.json';
import gridView from 'src/locales/en/gridView.json';
import guestList from 'src/locales/en/guestList.json';
import guestMobileAppCrossSell from 'src/locales/en/guestMobileAppCrossSell.json';
import header from 'src/locales/en/header.json';
import home from 'src/locales/en/home.json';
import honeymoonRegistry from 'src/locales/en/honeymoonRegistry.json';
import hotelRoomBlocks from 'src/locales/en/hotelRoomBlocks.json';
import languageMenu from 'src/locales/en/languageMenu.json';
import newsroom from 'src/locales/en/newsroom.json';
import onlineRsvp from 'src/locales/en/onlineRsvp.json';
import ourStory from 'src/locales/en/ourStory.json';
import pricing from 'src/locales/en/pricing.json';
import pricingCTA from 'src/locales/en/pricingCTA.json';
import rachelZoe from 'src/locales/en/rachelZoe.json';
import registry from 'src/locales/en/registry.json';
import saveTheDate from 'src/locales/en/saveTheDate.json';
import sections from 'src/locales/en/sections.json';
import seo from 'src/locales/en/seo.json';
import storefront from 'src/locales/en/storefront.json';
import testimonials from 'src/locales/en/testimonials.json';
import userContentCarousel from 'src/locales/en/userContentCarousel.json';
import weddingInvitations from 'src/locales/en/weddingInvitations.json';
import weddingWebsite from 'src/locales/en/weddingWebsite.json';
import weddingWebsitePage from 'src/locales/en/weddingWebsitePage.json';
import weddingWebsitesCarousel from 'src/locales/en/weddingWebsitesCarousel.json';

export const namespaces = [
  'allTheLittleDetails',
  'amazonRegistry',
  'app',
  'avatar',
  'babyRegistry',
  'blogCarousel',
  'careers',
  'carouselQuotes',
  'cashFundRegistry',
  'chatGPT',
  'demo',
  'designs',
  'errors',
  'eula',
  'faq',
  'findAnEvent',
  'findPerfectInvitationsSection',
  'footerNavs',
  'galleryPage',
  'getQuickAddButton',
  'gridView',
  'guestList',
  'guestMobileAppCrossSell',
  'header',
  'home',
  'honeymoonRegistry',
  'hotelRoomBlocks',
  'languageMenu',
  'newsroom',
  'onlineRsvp',
  'ourStory',
  'pricing',
  'pricingCTA',
  'rachelZoe',
  'registry',
  'saveTheDate',
  'sections',
  'seo',
  'storefront',
  'testimonials',
  'userContentCarousel',
  'weddingInvitations',
  'weddingWebsite',
  'weddingWebsitePage',
  'weddingWebsitesCarousel',
];

const resources = {
  allTheLittleDetails,
  amazonRegistry,
  app,
  avatar,
  babyRegistry,
  blogCarousel,
  careers,
  carouselQuotes,
  cashFundRegistry,
  chatGPT,
  demo,
  designs,
  errors,
  eula,
  faq,
  findAnEvent,
  findPerfectInvitationsSection,
  footerNavs,
  galleryPage,
  getQuickAddButton,
  gridView,
  guestList,
  guestMobileAppCrossSell,
  header,
  home,
  honeymoonRegistry,
  hotelRoomBlocks,
  languageMenu,
  newsroom,
  onlineRsvp,
  ourStory,
  pricing,
  pricingCTA,
  rachelZoe,
  registry,
  saveTheDate,
  sections,
  seo,
  storefront,
  testimonials,
  userContentCarousel,
  weddingInvitations,
  weddingWebsite,
  weddingWebsitePage,
  weddingWebsitesCarousel,
} as const;

export default resources;
